// Copyright (c) Move Closer 2022.

import {
  AppModule, Container, IConfiguration, Interfaces,
  Module
} from '@movecloser/front-core'

import { routesFactory as routes } from './routes'

@AppModule({
  name: 'poi',
  providers: (config: IConfiguration) => {
    return (bind: Interfaces.Bind) => {
      //
    }
  },
  boot (container: Container, config: IConfiguration) {
    //
  },
  routes
})
export class PoiModule extends Module {}
